"use client"

import * as React from "react"

import { Select, type SelectOption } from "@ibada/ui"
import { OverviewPeriodPreset } from "@/shared/model/overview-period"

type OverviewPeriodFilterProps = {
  value: OverviewPeriodPreset
  onChange: (value: OverviewPeriodPreset) => void
  labels: Record<OverviewPeriodPreset, string>
  includeCustom?: boolean
  triggerClassName?: string
  disabled?: boolean
}

const CANONICAL_PRESET_ORDER: OverviewPeriodPreset[] = [
  OverviewPeriodPreset.Today,
  OverviewPeriodPreset.ThisWeek,
  OverviewPeriodPreset.ThisMonth,
  OverviewPeriodPreset.ThisQuarter,
  OverviewPeriodPreset.ThisYear,
  OverviewPeriodPreset.Custom,
]

export function OverviewPeriodFilter({
  value,
  onChange,
  labels,
  includeCustom = true,
  triggerClassName = "w-[190px]",
  disabled = false,
}: OverviewPeriodFilterProps) {
  const options = React.useMemo(
    () =>
      CANONICAL_PRESET_ORDER.filter((preset) => includeCustom || preset !== OverviewPeriodPreset.Custom).map((preset) => ({
        value: preset,
        label: labels[preset],
      })) satisfies SelectOption<OverviewPeriodPreset>[],
    [includeCustom, labels],
  )

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled} options={options} className={triggerClassName} />
  )
}
